/**
 * Created by wuyanbin on 2019/7/12
 */
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
import React, { Component } from 'react';
import { Radio, Select, Button, Form, notification } from 'antd';
import styles from './index.less';
import FixedRateComponent from './_components/FixedRateComponent';
import FixedFeeComponent from './_components/FixedFeeComponent';
import Authorized from '@/components/Auth/auth';
import { checkLowUpperVal } from '@/shared/functions';
const { Option } = Select;
const mapStateToProps = (rootState) => ({
    sellerPayRules: rootState.sellerPayRules,
});
class SellerPayRules extends Component {
    constructor() {
        super(...arguments);
        this.onChangePayWay = (e) => {
            dispatch.sellerPayRules.handleChangePayWay(e.target.value);
        };
        this.handleChangeSubTypes = (value) => {
            dispatch.sellerPayRules.handleChangeSubTypes(value);
        };
        // 保存
        this.saveSellerPayConfig = (e) => {
            e.preventDefault();
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    if (checkLowUpperVal(values.FixedRateMin, values.FixedRateMax)) {
                        notification.warn({
                            message: '上限需大于等于下限',
                        });
                    }
                    else {
                        dispatch.sellerPayRules.saveSellerPayConfig({});
                    }
                }
            });
        };
        // 编辑
        this.editSellerPayConfig = () => {
            dispatch.sellerPayRules.editSellerPayConfig({});
        };
        // 取消
        this.cancelSellerPayConfig = () => {
            this.props.form.resetFields();
            dispatch.sellerPayRules.cancelSellerPayConfig({});
        };
        this.handleFixedRateChange = (payload) => {
            dispatch.sellerPayRules.handleFixedRate(payload);
        };
    }
    componentDidMount() {
        dispatch.sellerPayRules.getSellerPayConfig({});
    }
    render() {
        const { moreTimesSubTypes, moreTimesPay, isEditAble, FixedRateNum, FixedRateMin, FixedRateMax } = this.props.sellerPayRules;
        return (<Form className={styles.sellerPayConfigContainer}>
        <div>
          卖家车款分次结算：
          <Radio.Group onChange={this.onChangePayWay} value={moreTimesPay} disabled={!isEditAble}>
            <Radio value={true}>是</Radio>
            <Radio value={false}>否</Radio>
          </Radio.Group>
        </div>
        <div className={styles.tips}>请谨慎操作，分开结算会将订单拆分多次结算</div>
        
        {moreTimesPay &&
            <div className={styles.configArea}>
            
            <div className={styles.leftArea}>
              <Select value={moreTimesSubTypes} style={{ width: 120 }} onChange={this.handleChangeSubTypes} disabled={!isEditAble} getPopupContainer={(triggerNode) => {
                return triggerNode.parentNode;
            }}>
                <Option value="purchasePrice">采购价</Option>
                <Option value="fixedFee">固定费用</Option>
                <Option value="fixedRate">固定比例</Option>
              </Select>
            </div>
            
            {moreTimesSubTypes === 'fixedRate' ?
                <FixedRateComponent fixedRate={{
                    FixedRateNum,
                    FixedRateMin,
                    FixedRateMax,
                    isEditAble,
                    canInputZeroHundred: false,
                }} handleFixedRateChange={(payload) => {
                    this.handleFixedRateChange(payload);
                }} form={this.props.form}/> :
                moreTimesSubTypes === 'fixedFee' ? <FixedFeeComponent form={this.props.form}/> : ''}
          </div>}
        
        <div className={styles.submitBtn}>
          {!isEditAble ?
            <Authorized allow={'psgjb-mjjs-edit'}>
              <Button type="primary" onClick={this.editSellerPayConfig}>编辑</Button>
            </Authorized>
            :
                <React.Fragment>
              <Button style={{ marginRight: '10px' }} onClick={this.cancelSellerPayConfig}>取消</Button>
              <Button type="primary" onClick={this.saveSellerPayConfig}>保存</Button>
            </React.Fragment>}
        </div>
      </Form>);
    }
}
const WrappedSellerPayRules = Form.create({ name: 'SellerPayRules' })(SellerPayRules);
export default connect(mapStateToProps)(WrappedSellerPayRules);
